export const maskEmail = (e) => {
  if (!e || !e.includes("@")) return e;
  const s = e.toLowerCase();
  const at = s.indexOf("@");
  const local = s.slice(0, at);
  const dom = s.slice(at + 1);
  const di = dom.lastIndexOf(".");
  const domMasked = di > 0 ? dom[0] + "***" + dom.slice(di) : dom[0] + "***";
  return local[0] + "***@" + domMasked;
};
